export class LocalStore {
    constructor(key) {
        this.version = 3;
        this.key = key;
        const value = localStorage.getItem(key);
        const storedVersion = localStorage.getItem("version");
        if (storedVersion == null || value == null || value.startsWith("{") || parseInt(storedVersion) > this.version) {
            console.log("Localstore.init reset storage");
            localStorage.setItem(this.key, "[]");
            localStorage.setItem(key + ".bkp", value);
        }
    }
    save(items) {
        localStorage.setItem(this.key, JSON.stringify(items));
        localStorage.setItem("version", JSON.stringify(this.version));
    }
    load() {
        const item = localStorage.getItem(this.key);
        return JSON.parse(item);
    }
}
